import Image from "next/image";

import { formatImageUrl } from "@/components/blog/Util";
import { cn } from "@/lib/utils";
import { clashGrotesk, jakartaSans } from "@/styles/fonts";

import type { CaseStudy } from "@/pages/case-studies/[slug]";

export default function Hero({
  title,
  subtitle,
  heroImage,
  generalReboltStat,
}: Pick<CaseStudy, "title" | "subtitle" | "generalReboltStat"> & { heroImage: string }) {
  return (
    <section
      className={cn("md:py-20 py-12 md:mb-16 flex flex-col md:flex-row", jakartaSans.variable, clashGrotesk.variable)}
    >
      <div className="flex flex-col gap-12 md:gap-24 w-full items-center justify-center max-w-5xl mx-auto px-4">
        <section className="flex flex-col justify-center items-center shrink-0 text-center gap-10">
          <h1
            className="font-clash font-medium text-5xl md:text-7xl leading-[0.95] tracking-snug text-center relative"
            itemProp="headline"
          >
            {title}
          </h1>
          <div className="flex flex-col gap-8 md:gap-12 items-center justify-center">
            <p className="text-base md:text-xl text-center max-w-[760px]" itemProp="headline">
              {subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-12">
              {generalReboltStat.map((stat, index) => (
                <div key={index} className="flex flex-col gap-1">
                  <p className="text-2xl text-center font-clash font-semibold text-ash-900">{stat.fields.header}</p>
                  <p className="text-medium text-center text-ash-700">{stat.fields.subheader}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        {heroImage && (
          <div className="w-full max-h-[600px]">
            <Image
              width={500}
              height={500}
              sizes="(max-width: 768px) 90vw, 45vw"
              className="rounded-3xl shadow-sm w-full object-cover h-full"
              src={`${formatImageUrl(heroImage)}`}
              alt="Rebolt Customer Image"
              loading="eager"
              priority
            />
          </div>
        )}
      </div>
    </section>
  );
}
